/**
 * @ngdoc service
 * @name checkins.factory:testSelective
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('testSelective', testSelective);

function testSelective() {
    return {
        key: 'test-selective',
        title: 'Selective',
        level: 'global',
        class: 'btn btn-default',
        action: save
    };

    function save(contact, vm) {
        contact.selectiveSave({invalid: true});
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/test-selective.js